export const toKebabCase = (str: string) => str.replace(/([A-Z])/g, '-$1').toLowerCase();
